export default {
    SET_INITIAL_MERGE_FIELDS(state, initialMergeFields) {
        state.initialMergeFields = initialMergeFields;
    },

    SET_INITIAL_MERGE_SERVICE_FIELDS(state, initialMergeServiceFields) {
        state.initialMergeServiceFields = initialMergeServiceFields;
    },
};
